/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import Icon from '@material-ui/core/Icon';
import React from 'react';
import GeneticResourceIcon from '../../components/icons/GeneticResourceIcon';

export const getIconComponent = (icon) => {
  switch (icon) {
    case 'geneticResourceIcon':
      return <GeneticResourceIcon />;
    default:
      return <Icon>{icon}</Icon>;
  }
};
